import Vue from "vue";

/**
 * 
 * @param {string} message mensagem
 * @param {("success"|"error")} type tipo de mensagem
 */
const toast = (message, type) => Vue.$toast.open({
    message,
    type,
    position: "top-right",
    duration: 5000
});

export default toast;